import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { SearchInput } from '@dev/ee-components';

import useMobile from '@/services/hooks/useMobile';
import { debounce } from '@/services/tools/debounce';
import { SegmentsLoadStart } from '@/store/segments/actions';
import { useRequestParams } from '../../hooks/useRequestParams';

export const SearchComponent: FC = (): JSX.Element => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const isMobile = useMobile();
    const params = useRequestParams();

    const handleSearch = (e?: any) => {
        const search = e?.currentTarget?.value || '';
        const timeout = search ? 500 : 0;
        debounce(() => {
            const segmentsLoadParams = {
                limit: params.perPage,
                offset: 0,
                ...(!!search && { searchName: search }),
            };

            dispatch(SegmentsLoadStart(segmentsLoadParams));
        }, timeout);
    };

    return (
        <div style={{ margin: isMobile ? '32px 0px' : '24px 48px' }}>
            <SearchInput
                id="search-for-segments-input"
                placeholder={t('searchforsegments')}
                type="text"
                defaultValue={params.searchName}
                onChange={handleSearch}
                onDelete={handleSearch}
            />
        </div>
    );
};
